import Flickity from "Flickity";

jQuery(function ($) {
  let heroSlider = $(".hero-slider");
  let hasMultipleCells = heroSlider.find(".toppblock-front-backg-img__img").length;

  if (hasMultipleCells > 1) {
    new Flickity(heroSlider[0], {
      contain: true,
      autoPlay: true,
      prevNextButtons: false,
    });
  }
});
